// extracted by mini-css-extract-plugin
export default {"Details":"Details_Details__DmS4R","backButton":"Details_backButton__Mvj8T"};